import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";  // Import useLocation to access the state
import PregnancyIcon from "../../assets/images/icons/mom-4.png";
import babyicon from "../../assets/images/icons/weekly-pregnancy-tracker-4.png";
import nutritionTipsIcon from "../../assets/images/icons/nutrition-4.png";
import whatsNextIcon from "../../assets/images/icons/whats-next-4.png";
import PregnancyIconHighmark from "../../assets/images/highmark/icons/mom-4.png";
import babyiconHighmark from "../../assets/images/highmark/icons/weekly-pregnancy-tracker-4.png";
import nutritionTipsIconHighmark from "../../assets/images/highmark/icons/nutrition-4.png";
import whatsNextIconHighmark from "../../assets/images/highmark/icons/whats-next-4.png";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const BabyDevlopment = () => {
  const [data, setData] = useState(null);  // Holds the data from the API
  const [dataType, setDataType] = useState("");
  const [weeks,setSelectedweek] =useState("")
  const { state } = useLocation();  // Get the state passed from the previous component
  const { value,week  } = state || {};  // Destructure the state to get 'value'

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const [loading, setLoading] = useState(true);
  
  
  const userInfo = useSelector((state) => state.userData);
  const token = localStorage.getItem('AccessToken');
  const { t } = useTranslation();
  const navigate = useNavigate();
  // Set the dataType based on the passed value
  useEffect(() => {
    if (value && week) {
      setDataType(value);
      setSelectedweek(week)  // Set the dataType to the value passed from the previous page
    }
  }, [value,week]);  // Run when 'value' changes

  // Mapping for header text based on dataType
  const headerText = {
    Baby: "Baby's Development",
    Body: "Your Changing Body",
    Nutrition: "Nutrition Tips",
    Tests: "Upcoming Tests",
  };

  const images = {
    Body: PregnancyIcon,
    Baby: babyicon,
    Nutrition: nutritionTipsIcon,
    Tests: whatsNextIcon,
  };

  const imagesHighmark = {
    Body: PregnancyIconHighmark,
    Baby: babyiconHighmark,
    Nutrition: nutritionTipsIconHighmark,
    Tests: whatsNextIconHighmark,
  };

  // Function to fetch data from the API
  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        DataType: dataType,  // Use the current dataType
        WeekNo: weeks,  // Static for now (You can modify this if needed)
        EmailID: userInfo.userData.EmailID,
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",  // Static for now (You can modify this if needed)
      };

      const response = await axios.post(
        Endpoints.LoadMaternityWeeklyTracker,
        { _Params: JSON.stringify(params) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(response.data);  // Set the fetched data into state
    } catch (error) {
      console.error("Error fetching data:", error);
    }finally {
      setLoading(false); // <-- Ensure loading is set to false after fetch
    }
  };

  // Fetch data whenever the dataType changes
  useEffect(() => {
    if (dataType && weeks) {
      fetchData();
    }
  }, [dataType, weeks]);  // Dependency array ensures it triggers on dataType change

  // Function to handle back button click
  const handleBackClick = () => {
    navigate(-1);  // Navigate to the previous page
  };
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>
      <div className="col-2 col-md-2 mt-4 d-flex inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}><span><i className='bi bi-chevron-left'></i> {t('back')}</span></button>
        <h2 className="page-heading">&nbsp;</h2>
      </div>

      <div className="col-10 col-md-10 mt-4 d-flex justify-content-end flex-sm-row flex-wrap align-items-center gap-1">
        <button
          className="win-btn-with-icon baby-btn"
          onClick={() => setDataType("Baby")}
        >
          BABY
        </button>
        <button
          className="win-btn-with-icon mom-btn ms-1"
          onClick={() => setDataType("Body")}
        >
          MOM
        </button>
        <button
          className="win-btn-with-icon nutrition-btn ms-1"
          onClick={() => setDataType("Nutrition")}
        >
          NUTRITION
        </button>
        <button
          className="win-btn-with-icon whats-next-btn ms-1"
          onClick={() => setDataType("Tests")}
        >
          WHAT'S NEXT
        </button>
      </div>

      <div className="weekly-tracker-inner-pages">
        <div className="weekly-tracker-inner-page-icon-wrapper">
          {/* Displaying the corresponding image based on the dataType */}
          {isHighmarkPortal ? 
            <img src={imagesHighmark[dataType]} alt="highmark icon" className="weekly-tracker-icon" />
          :
            <img src={images[dataType]} alt="win icon" className="weekly-tracker-icon" />
          }
          
        </div>
        <div className="weekly-tracker-inner-page-content-wrapper">
          <h2 className="page-heading">
            {/* Displaying the header based on dataType */}
            {headerText[dataType] || "Loading..."} {/* Fallback if dataType is not found */}
          </h2>

          <p className="mb-5">
            {/* Displaying the header from the API */}
            {data ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: data.ScreenHeader,
                }}
              />
            ) : (
              "Loading..."
            )}
          </p>

          {/* Mapping over the topics */}
          {data && data.Topics && data.Topics.length > 0 ? (
  data.Topics.map((topic, index) => (
    topic.TopicDetails && topic.TopicDetails.trim() !== "" ? ( // Check if TopicDetails is not empty
      <div key={index} className="weekly-tracker-inner-page-block">
        {/* Displaying the TopicHeader as h3 */}
        <h3 className="block-heading">{topic.TopicHeader}</h3>
        {/* Displaying the TopicDetails (which is HTML content) */}
        <p
          className="block-content"
          dangerouslySetInnerHTML={{
            __html: topic.TopicDetails,
          }}
        />
      </div>
    ) : null  // Do not render if TopicDetails is empty
  ))
) : (
  <p>No information available for this category.</p>
)}
 <p className="mb-5">
            {/* Displaying the header from the API */}
            {data ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: data.ScreenFooter,
                }}
              />
            ) : (
              "Loading..."
            )}
          </p>

        </div>
      </div>
    </>
  );
};

export default BabyDevlopment;
